export default __webpack_public_path__ + "static/media/erick.16cfe6cb.jpg";